var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGrLogo = function SvgGrLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "GRLogo_svg__Layer_1",
    width: 20,
    height: 20,
    "data-name": "Layer 1",
    viewBox: "0 0 102.98 49.23"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".GRLogo_svg__cls-3{fill-rule:evenodd;stroke-width:0;fill:#fefefe}"))), /*#__PURE__*/React.createElement("path", {
    d: "M57.63 0h-.94L44.3 49.23h46.3L102.98 0z",
    style: {
      fillRule: "evenodd",
      strokeWidth: 0,
      fill: "#e50113"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.38 0 0 49.23h45.04L57.43 0z",
    style: {
      fill: "#231916",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.09 26.7c-.38 2.01-.8 3.17-1.47 4.5-1.24 2.48-3.75 3.83-7.28 4.31-1.38.18-3.23.12-3.23.12l7.38 10.48H77.55L67.3 31.53s8.92-.02 9.85-.02c2.13 0 4.96-.63 5.74-2.09.24-.45.58-1.2.59-1.99 0-.99-.96-1.82-2.59-1.82s-16.05-.01-16.05-.01l-5.08 20.24H49.41l6.5-25.22h29.64c5.55 0 8.15 2.8 7.51 6.11ZM45.76 31.02l-17.05.02-1.6 4.79h8.47l-1.38 4.62H20.54c-2.98 0-4.23-.73-3.93-2.82.33-2.37 1.22-4.38 2.03-6.58 1.64-4.45 4.01-5.58 13.89-5.58h14.79l1.56-5.01H31.12c-14.47 0-19.43 1.69-22.19 8.77-.94 2.4-2.34 6.83-2.97 10.49-.74 4.3 2.59 5.98 6.13 6.1 4.9.16 29.49.09 29.49.09l4.18-14.88Z",
    className: "GRLogo_svg__cls-3"
  })));
};
export default SvgGrLogo;